/* TotCloset: theme scripts (no dependencies) */
(() => {
  const routes = window.theme?.routes || {};
  const root = routes.root || '/';
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ---------- Drawers (menu, cart, filters) ---------- */
  let lastFocus = null;
  const openDrawer = (drawer) => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => drawer.querySelector('button, a, input')?.focus({ preventScroll: true }), 50);
  };
  const closeDrawer = (drawer) => {
    if (!drawer?.hasAttribute('open')) return;
    drawer.removeAttribute('open');
    if (!$('.drawer[open]')) document.documentElement.style.overflow = '';
    lastFocus?.focus?.({ preventScroll: true });
  };
  const menuDrawer = $('[data-drawer]');
  const cartDrawer = () => $('[data-cart-drawer]');
  const filterDrawer = $('[data-filter-drawer]');

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-drawer-toggle]')) openDrawer(menuDrawer);
    else if (t.closest('[data-drawer-close]')) closeDrawer(menuDrawer);
    else if (t.closest('[data-cart-close]')) closeDrawer(cartDrawer());
    else if (t.closest('[data-filters-open]')) openDrawer(filterDrawer);
    else if (t.closest('[data-filters-close]')) closeDrawer(filterDrawer);
    else if (t.closest('[data-cart-open]') && cartDrawer() && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openDrawer(cartDrawer());
      loadCartRecs();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer[open]').forEach(closeDrawer);
    closeMega();
    closeSearch();
  });

  /* ---------- Header: scrolled state ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Announcement rotator ---------- */
  const msgs = $$('.announcement__msg');
  if (msgs.length > 1 && !reduceMotion) {
    let i = 0;
    setInterval(() => {
      const cur = msgs[i];
      i = (i + 1) % msgs.length;
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      setTimeout(() => cur.classList.remove('is-leaving'), 500);
      msgs[i].classList.add('is-active');
    }, 4500);
  }

  /* ---------- Mega menu ---------- */
  const megaItems = $$('.nav__item--mega');
  const closeMega = () => megaItems.forEach((li) => {
    li.classList.remove('is-open');
    $('[data-mega-toggle]', li)?.setAttribute('aria-expanded', 'false');
  });
  megaItems.forEach((li) => {
    const btn = $('[data-mega-toggle]', li);
    let timer;
    const open = () => { clearTimeout(timer); closeMega(); li.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
    btn.addEventListener('click', () => (li.classList.contains('is-open') ? closeMega() : open()));
    if (window.matchMedia('(hover: hover)').matches) {
      li.addEventListener('mouseenter', () => { clearTimeout(timer); timer = setTimeout(open, 80); });
      li.addEventListener('mouseleave', () => { clearTimeout(timer); timer = setTimeout(closeMega, 180); });
    }
    li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) closeMega(); });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('.nav__item--mega')) closeMega(); });

  /* ---------- Predictive search ---------- */
  const overlay = $('[data-search-overlay]');
  const searchInput = $('[data-predictive-input]');
  const results = $('[data-predictive-results]');
  const defaultResults = results?.innerHTML;
  const openSearch = () => {
    if (!overlay) return;
    closeMega();
    overlay.hidden = false;
    $('[data-search-open]')?.setAttribute('aria-expanded', 'true');
    searchInput?.focus();
  };
  const closeSearch = () => {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    $('[data-search-open]')?.setAttribute('aria-expanded', 'false');
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { overlay?.hidden ? openSearch() : closeSearch(); }
    else if (e.target.closest('[data-search-close]')) closeSearch();
    else if (overlay && !overlay.hidden && !e.target.closest('[data-search-overlay]')) closeSearch();
  });
  let searchCtrl;
  searchInput?.addEventListener('input', debounce(async () => {
    const q = searchInput.value.trim();
    if (!q) { results.innerHTML = defaultResults; return; }
    searchCtrl?.abort();
    searchCtrl = new AbortController();
    try {
      const url = `${routes.search_url}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6&resources[options][prefix]=last&section_id=predictive-search`;
      const html = await fetch(url, { signal: searchCtrl.signal }).then((r) => r.text());
      const section = parseHTML(html).querySelector('.shopify-section');
      results.innerHTML = section ? section.innerHTML : '';
    } catch (_) { /* aborted */ }
  }, 220));

  /* ---------- Cart: shared helpers ---------- */
  const setCount = (n) => $$('[data-cart-count]').forEach((el) => {
    el.textContent = n;
    el.hidden = n === 0;
    el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
  });
  const swapCartDrawer = (html) => {
    if (!html) return;
    const fresh = parseHTML(html).querySelector('[data-cart-drawer-inner]');
    const current = $('[data-cart-drawer-inner]');
    if (fresh && current) current.replaceWith(fresh);
  };
  const refreshCart = async () => {
    const [sections, cart] = await Promise.all([
      fetch(`${root}?sections=cart-drawer`).then((r) => r.json()),
      fetch(`${routes.cart_url}.js`).then((r) => r.json()),
    ]);
    swapCartDrawer(sections['cart-drawer']);
    setCount(cart.item_count);
  };
  const addToCart = async (formData) => {
    const res = await fetch(`${routes.cart_add_url}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message);
    await refreshCart();
    openDrawer(cartDrawer());
    loadCartRecs();
    return json;
  };

  // Line quantity changes inside the drawer
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    const line = Number(btn.closest('[data-line]').dataset.line);
    const panel = $('[data-cart-drawer-inner]');
    panel?.classList.add('is-loading');
    try {
      const res = await fetch(`${routes.cart_change_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity: Number(btn.dataset.lineChange), sections: ['cart-drawer'] }),
      });
      const cart = await res.json();
      swapCartDrawer(cart.sections?.['cart-drawer']);
      setCount(cart.item_count);
      loadCartRecs();
    } finally {
      $('[data-cart-drawer-inner]')?.classList.remove('is-loading');
    }
  });

  // "Tottie also loves" recommendations in the drawer
  const recsCache = {};
  async function loadCartRecs() {
    const box = $('[data-cart-recs]');
    const pid = box?.dataset.productId;
    if (!box || !pid) return;
    try {
      recsCache[pid] ||= await fetch(`${routes.recs_url}.json?product_id=${pid}&limit=6`).then((r) => r.json());
      const inCart = new Set($$('.cd-item__title').map((a) => a.textContent.trim()));
      const items = recsCache[pid].products.filter((p) => !inCart.has(p.title)).slice(0, 4);
      if (!items.length) return;
      $('[data-cart-recs-track]', box).innerHTML = items.map((p) => `
        <a class="cd-rec" href="${p.url}">
          <span class="cd-rec__img">${p.featured_image ? `<img src="${p.featured_image}&width=300" alt="" loading="lazy">` : ''}</span>
          ${p.title}<span>${formatMoney(p.price)}</span>
        </a>`).join('');
      box.hidden = false;
    } catch (_) { /* optional */ }
  }
  const formatMoney = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100); }
    catch (_) { return `$${(cents / 100).toFixed(2)}`; }
  };

  /* ---------- Quick add on product cards ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    const btn = e.submitter;
    const fd = new FormData(form);
    if (btn?.name === 'id') fd.set('id', btn.value);
    btn?.classList.add('is-loading');
    try { await addToCart(fd); }
    catch (err) { alert(err.message); }
    finally { btn?.classList.remove('is-loading'); }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    const min = Number(input.min || 0);
    input.value = Math.max(min, Number(input.value || 0) + Number(btn.dataset.qty));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart page: auto-update on qty change ---------- */
  const cartForm = $('[data-cart-form]');
  if (cartForm) {
    const submit = debounce(() => cartForm.requestSubmit(cartForm.querySelector('[name="update"]')), 450);
    cartForm.addEventListener('change', (e) => { if (e.target.matches('input[name="updates[]"]')) submit(); });
  }

  /* ---------- Collection: sort auto-submit ---------- */
  $$('[data-autosubmit]').forEach((el) => el.addEventListener('change', () => el.form.submit()));

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach((root) => {
    const tabs = $$('[role="tab"]', root);
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
      });
      updateArrows(root);
    }));
  });

  /* ---------- Carousels ---------- */
  const activeCarousel = (scope) => $$('[data-carousel]', scope).find((c) => c.offsetParent !== null);
  function updateArrows(scope) {
    const c = activeCarousel(scope);
    const prev = $('[data-carousel-prev]', scope);
    const next = $('[data-carousel-next]', scope);
    if (!c || !prev) return;
    prev.disabled = c.scrollLeft < 8;
    next.disabled = c.scrollLeft + c.clientWidth >= c.scrollWidth - 8;
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    const scope = btn.closest('section');
    const c = activeCarousel(scope);
    if (!c) return;
    const dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    c.scrollBy({ left: dir * c.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
  const wireCarousels = (scope = document) => $$('[data-carousel]', scope).forEach((c) => {
    if (c.dataset.wired) return;
    c.dataset.wired = '1';
    const section = c.closest('section');
    c.addEventListener('scroll', debounce(() => updateArrows(section), 60), { passive: true });
    updateArrows(section);
  });
  wireCarousels();
  window.addEventListener('resize', debounce(() => $$('section').forEach(updateArrows), 150));

  /* ---------- Reveal on scroll ---------- */
  const revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); revealObserver.unobserve(en.target); }
      }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;
  const observeReveals = (scope = document) => $$('[data-reveal]:not(.is-in)', scope).forEach((el) => {
    if (revealObserver) revealObserver.observe(el); else el.classList.add('is-in');
  });
  observeReveals();
  // Theme editor: re-run when sections are added/changed
  document.addEventListener('shopify:section:load', (e) => { observeReveals(e.target); wireCarousels(e.target); });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach((root) => {
    const data = JSON.parse($('[data-product-json]', root).textContent);
    const form = $('[data-product-form]', root);
    const idInput = form.querySelector('[name="id"]');
    const addBtn = $('[data-add]', form);
    const priceEl = $('[data-price]', root);
    const track = $('[data-gallery-track]', root);
    const dots = $$('[data-gallery-dots] button', root);
    const strings = data.strings;
    const sticky = $('[data-sticky-atc]');
    let current = null;

    // Gallery dots (mobile carousel)
    if (track && dots.length) {
      const items = $$('.gallery__item', track);
      track.addEventListener('scroll', debounce(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((d, j) => d.setAttribute('aria-current', i === j));
      }, 40), { passive: true });
      dots.forEach((d, i) => d.addEventListener('click', () => items[i]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })));
    }
    const showMedia = (mediaId) => {
      const item = mediaId && $(`.gallery__item[data-media-id="${mediaId}"]`, root);
      if (!item) return;
      if (window.matchMedia('(min-width: 990px)').matches) return; // desktop shows all images
      track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
    };

    const selected = () => $$('[data-option]', root).map((fs) => fs.querySelector('input:checked')?.value);
    const render = () => {
      const opts = selected();
      const variant = data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      current = variant;
      $$('[data-option]', root).forEach((fs, i) => {
        const label = $('[data-option-value]', fs);
        if (label) label.textContent = opts[i] || '';
        $$('input', fs).forEach((input) => {
          const test = [...opts];
          test[i] = input.value;
          const ok = data.variants.some((v) => v.available && v.options.every((o, j) => o === test[j]));
          input.closest('.pill')?.classList.toggle('pill--unavailable', !ok);
        });
      });
      const stickyBtn = $('[data-sticky-add]');
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = strings.unavailable;
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = strings.unavailable; }
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? strings.add : strings.soldOut;
      if (stickyBtn) { stickyBtn.disabled = !variant.available; stickyBtn.textContent = addBtn.textContent; }
      const sv = $('[data-sticky-variant]');
      if (sv && data.variants.length > 1) sv.textContent = variant.title;
      if (priceEl) {
        const onSale = variant.compare_at_price > variant.price;
        priceEl.classList.toggle('price--sale', onSale);
        priceEl.innerHTML = `<span class="price__current">${data.money[variant.id]}</span>` + (onSale ? `<s>${data.compare[variant.id]}</s>` : '');
      }
      showMedia(variant.featured_media?.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    root.addEventListener('change', (e) => { if (e.target.closest('[data-option]')) render(); });
    render();

    const submit = async () => {
      addBtn.disabled = true;
      const label = addBtn.textContent;
      addBtn.textContent = strings.adding;
      try { await addToCart(new FormData(form)); }
      catch (err) { alert(err.message || strings.error); }
      finally { addBtn.disabled = !current?.available; addBtn.textContent = label; }
    };
    form.addEventListener('submit', (e) => { e.preventDefault(); submit(); });

    // Sticky add-to-cart bar
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', !show);
        $('[data-sticky-add]', sticky).tabIndex = show ? 0 : -1;
      }).observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', () => {
        if ($$('[data-option]', root).length && !current) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        submit();
      });
    }

    // Remember for "Recently viewed"
    try {
      const key = 'tc:recent';
      const handle = root.dataset.productHandle;
      const list = JSON.parse(localStorage.getItem(key) || '[]').filter((h) => h !== handle);
      list.unshift(handle);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    } catch (_) { /* storage unavailable */ }
  });

  /* ---------- Related products (lazy) ---------- */
  $$('[data-related]').forEach(async (sec) => {
    const track = $('[data-related-track]', sec);
    if (track.children.length) return;
    try {
      const html = await fetch(sec.dataset.url).then((r) => r.text());
      const fresh = parseHTML(html).querySelector('[data-related-track]');
      if (fresh && fresh.children.length) {
        track.replaceWith(fresh);
        observeReveals(sec);
        wireCarousels(sec);
      } else sec.remove();
    } catch (_) { sec.remove(); }
  });

  /* ---------- Recently viewed ---------- */
  const recent = $('[data-recently-viewed]');
  if (recent) {
    (async () => {
      let handles = [];
      try { handles = JSON.parse(localStorage.getItem('tc:recent') || '[]'); } catch (_) { return; }
      handles = handles.filter((h) => h !== recent.dataset.current).slice(0, 8);
      if (!handles.length) return;
      const products = (await Promise.all(handles.map((h) => fetch(`${root}products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)))).filter(Boolean);
      if (!products.length) return;
      $('[data-recent-track]', recent).innerHTML = products.map((p) => `
        <div class="carousel__slide">
          <article class="card">
            <div class="card__media"><a class="card__link" href="${p.url}">${p.featured_image ? `<img class="card__img" src="${p.featured_image}&width=500" alt="" loading="lazy">` : ''}</a></div>
            <div class="card__body"><h3 class="card__title"><a href="${p.url}">${p.title}</a></h3><div class="price">${formatMoney(p.price)}</div></div>
          </article>
        </div>`).join('');
      recent.hidden = false;
      wireCarousels(recent);
    })();
  }
})();
